<template>
  <div class="quiz__step" id="step-6">
    <div class="quiz__tab-item-wrap">
      <div class="quiz__aside">

        <btn-back
            :text="translate.masterBackText"
            @backToStep="backToStep"
        />

        <div class="quiz-checks checks-for-material" v-for="material in materials" :key="material.id+'mq4'" data-material="{{ material.value }}" v-show="materialParam == material.value" >

          <div v-for="variant in getVariants(material.variants, 'five')" :key="variant.id">
            <label class="radio" v-if="checkMaterial(variant.value)" :ref="'temp_'+variant.id" :class="variant.value == threadVal ? 'checked' : ''">
              <input type="radio" v-model="threadVal" name="step-5" :value="variant.value" class="param-{{ variant.id }}" />
              <div class="radio__text">{{ variant.name }}</div>
            </label>
          </div>

        </div>


      </div>
      <div class="quiz__content">
        <div v-if="texts && texts['threadText'+lang]" v-html="texts['threadText'+lang]">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import BtnBack from "../BtnBack.vue";
import {default as axios} from "axios";
import qs from "querystring";
export default {
  name: "threadParamComponent",
  components: {BtnBack},
  props: ['translate', 'materials', 'materialParam', 'letterType', 'threadParam', 'texts', 'lang', 'step', 'marking'],
  data(){
      return{
          oldStep: this.step,
          loader: 0
      }
  },

  computed:{
    threadVal:{
        get(){
            return this.threadParam;
        },
        set(newVal){

            this.$emit('changeThreadParam', newVal);
        }
    }
  },

  methods: {
    backToStep() {
      this.$emit('backToStep')
    },
    getVariants(variants, name) {
      return (variants.filter(element => element.step == name));
    },

    //варианты Резьба узла крепления
    checkMaterial(val){

      //Для гибких чувствительных элементов “Г”, “Д”, “В” доступна только одна резьба G1,5” (написали в замечания)
      if((this.letterType == 'Г' || this.letterType == 'Д' || this.letterType == 'В' || this.letterType == 'К' || this.letterType == 'Н') && val != 1){
        return false;
      }

      return true;
    },

    findMarking(threadParam, key){

      if(this.marking) {

        let name = (this.marking.numberType ? (this.marking.letterType ? this.marking.numberType + this.marking.letterType : '') : '')
            + ('000' + this.marking.longParam).slice(-3)
            + '-' + threadParam
            + this.marking.voltageParam;


        this.loader++;
        axios
            .post('/directrequest/catalog/master/find-marking.json/', qs.stringify({
              marking: name
            }))
            .then((response) => {
              this.loader--;
              if (!Boolean(response.data) && this.$refs[key]) {
                $(this.$refs[key][0]).addClass('disable-param');
                $(this.$refs[key][0]).find('input').prop("disabled", true);
              }
            })
            .catch((error) => {
              this.loader--;
              console.log(error);
            });
      }

    },

    hasLetter(){
      return (this.letterType == 'Г' || this.letterType == 'Д' || this.letterType == 'В');
    }
  },

  watch:{
    step(){

      if(this.step < 6){
        $('.disable-param').each(function(i){
          $(this).removeClass('disable-param');
          $(this).find('input').prop( "disabled", false );
        });
      }


      if(this.oldStep < this.step) {
        //любо от сюда перелестнуть на слеюущий
        // либо из предыдущего шага сразу пропускать этот
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        if (this.step == 6 && this.hasLetter() ) {
          this.$emit('changeThreadParam', 1);
          this.$emit('nextStep');
        }
      }
      if(this.oldStep > this.step) {
        //любо от сюда перелестнуть на слеюущий
        // либо из предыдущего шага сразу пропускать этот
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        if (this.step == 6 && this.hasLetter()) {
          this.$emit('changeThreadParam', '');
          this.$emit('backToStep');
        }
      }

      if(this.step == 6){
        for (var material in this.materials) {

          let v = this.getVariants(this.materials[material].variants, 'five');

          for (var variant in v) {
            this.findMarking(v[variant].value, 'temp_'+v[variant].id);
          }

        }
      }

      this.oldStep = this.step;

    }
  }
}
</script>

<style scoped>

</style>